// src/i18n/table.ts —— table 域基础包（mergePagePacks 的 base，TD-849）：J 组多页共用的键只能定义在这里，页包重复定义会被冲突检查拒绝。
// errExportLimit / featurePending / toastNoPerm 等已在外壳包（i18n/shell.ts、i18n/errors.ts），required 为原型键，均不重复定义
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_TABLE: I18nPack = {
  zh: {
    errSameReviewer: '二级审批需由另一名管理员执行', // 06 C-08 / C-29
    stUnknown: '待对账', // 06 C-05
    toastResolve: '已提交结案', // 06 C-29
    aResolve: '人工结案', // 06 C-27 / C-29
    stBudgetDeleted: '已删除', // 06 C-13 预算列 / C-27 状态列共用
    myPwdTip: '修改后所有设备（含当前）需重新登录。', // 06 C-21 修改密码 tip [改写]（S-86）
    // 以下本计划定稿，W-7 回写
    errNoteRequired: '请填写备注',
    errReason: '请填写原因（1～255 字）',
    errReason10: '原因至少 10 个字',
    errTxHash: '交易哈希格式不正确或已被使用',
    errAmountMin1: '金额不能低于 1.00',
    upstreamWord: '上游',
    cOutcome: '结案结论',
    cReason: '原因', // 06 C-27 预算表单 / C-28 暂扣·释放表单「原因 reason」原文（多页共用）
    resolveTip: '结论须与上游实际结果一致：上游已生效选「成功」，未生效选「失败」（失败将回滚冻结与预算）',
    markPaidTip: '人工兜底：仅在财务确认已用其他钱包手工付款时使用，填写 {network} 链上交易哈希。正常付款由财务工作台完成，无需在此操作；重复付款无法追回。',
  },
  en: {
    errSameReviewer: 'The second approval must be done by a different admin', // 06 C-08 / C-29
    stUnknown: 'Reconciling', // 06 C-05
    // 以下本计划定稿，W-7 回写（toastResolve / aResolve / stBudgetDeleted 的 06 原文只有中文）
    toastResolve: 'Resolution submitted',
    aResolve: 'Resolve manually',
    stBudgetDeleted: 'Deleted',
    myPwdTip: 'All devices, including this one, must sign in again after the change.',
    errNoteRequired: 'Please add a note',
    errReason: 'Enter a reason (1–255 chars)',
    errReason10: 'Reason must be at least 10 characters',
    errTxHash: 'Invalid or already-used transaction hash',
    errAmountMin1: 'Amount must be at least 1.00',
    upstreamWord: 'Upstream',
    cOutcome: 'Outcome',
    cReason: 'Reason',
    resolveTip: 'The outcome must match the actual upstream result: choose Success if it took effect upstream, Failed if not (failure rolls back holds and budget)',
    markPaidTip: 'Manual fallback: use only if finance confirms a manual payment from another wallet, and enter the {network} transaction hash. Normal payouts run in the Finance Console; duplicate payments cannot be recovered.',
  },
};

// myPwdTip：账号区修改密码表单（table 域表单机制渲染）的原型 tip 与 S-86 口径不符，按 06 改写
export const REWRITES_TABLE: readonly string[] = ['myPwdTip'];
